"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
var NumberOfBirths = /** @class */ (function (_super) {
    __extends(NumberOfBirths, _super);
    function NumberOfBirths(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = {
            value: state.data.number_of_birth,
            error: state.error.number_of_birth
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            if (_this._isMounted) {
                var state_1 = form_store_1.default.getState();
                _this.setState({
                    value: state_1.data.number_of_birth,
                    error: state_1.error.number_of_birth
                });
            }
        });
        return _this;
    }
    NumberOfBirths.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    NumberOfBirths.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    NumberOfBirths.prototype.render = function () {
        var _a = this.state, value = _a.value, error = _a.error, errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("div", { className: "input-set" },
                react_1.default.createElement("div", { className: "input-set__s input-select" },
                    react_1.default.createElement("select", { className: "input-select__select", id: "baby-count", name: "number_of_birth", onChange: input_actions_1.default.changeInput }, (function () {
                        var options = new Array();
                        // Options 設定
                        options.push(react_1.default.createElement("option", { value: "", key: 0 }, "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"));
                        for (var i = 1; i <= 4; i++) {
                            options.push(react_1.default.createElement("option", { value: i, key: i }, i));
                        }
                        return options;
                    })())),
                react_1.default.createElement("span", { className: "input-set__unit" }, "\u4EBA"))));
    };
    return NumberOfBirths;
}(react_1.Component));
exports.default = NumberOfBirths;
